<template>
    <div>
        <div class="big-title">
            <span>污染物信息</span>
        </div>
        <a-row>
            <a-col span="2"></a-col>
            <a-col :span="20">
                <div class="box" style="text-align: left">
                    {{localValue}}
                    <div style="display: inline-block;height: 25px;width: 1px"></div>
                </div>
            </a-col>
            <a-col :span="2">
                <a-button v-if="!disabled" type="link" @click="reChoice(item)">选择</a-button>
            </a-col>
        </a-row>
        <bad-check-panel-modal  v-if="modalVisable" :visible.sync="modalVisable"
                                :param="modalParam"
                                @dialogBack="onModalClose"></bad-check-panel-modal>
    </div>
</template>

<script>
    import mixin from '../mixin/AExtStringMixin'
    import BadCheckPanelModal from './BadCheckPanelModal'
    export default {
        name: "AExtBadThingsSelect",
        components:{BadCheckPanelModal},
        mixins:[mixin],
        props:{
            projectId:{
                type:String,
                default:''
            },
            disabled:{
                type:Boolean,
                default: false
            }
        },
        data(){
            return{
                localValue:'',
                modalParam:{},
                modalVisable:false
            }
        },
        methods:{
            reChoice(){
                this.modalParam={projectId:this.projectId}
                this.modalVisable=true;
            },
            onModalClose(val){
                this.localValue=val.badThings;
            }
        }
    }
</script>

<style scoped>
    .box{
        min-height: 40px;
        display: block;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-top-width: 1.02px;
        border-radius: 4px;
        outline: none;
        -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        text-align: center;
        padding-left: 5px;
        font-weight: 700;
        color: #7c7c7c;
    }

    .total-box{
        min-height: 40px;
        font-weight: 700;
        color: #7c7c7c;
    }

    .big-title{
        color: #444444;
        font-weight: 700;
    }

</style>